import ScrollTopButton from "../../../components/ScrollTopButton/ScrollTopButton"
import MyPageTheme from "../../../components/mypage/MyPageTheme"

type Props = {
  children: React.ReactNode
}

const SeminarTemplate = ({ children }: Props) => {
  return (
    <MyPageTheme>
      {children}
      <ScrollTopButton />
    </MyPageTheme>
  )
}

export default SeminarTemplate
